import { render } from "./Index2.vue?vue&type=template&id=b3e1747c"
import script from "./Index2.vue?vue&type=script&lang=js"
export * from "./Index2.vue?vue&type=script&lang=js"

import "./Index2.vue?vue&type=style&index=0&id=b3e1747c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__